module.exports = __webpack_public_path__ + "img/restart-banner.b72129e5.jpg";